import { ApiClient } from '@zolotalk/api-client';
import { createLearningApi } from '@zolotalk/api-client/endpoints/learning';
import { createTranslationApi } from '@zolotalk/api-client/endpoints';
import { createVoiceApi } from '@zolotalk/api-client/endpoints';
import { createOcrApi } from '@zolotalk/api-client/endpoints';
import { createHistoryApi } from '@zolotalk/api-client/endpoints';
import { createVocabularyApi } from '@zolotalk/api-client/endpoints';
import { createAccountApi } from '@zolotalk/api-client/endpoints';
import { webTokenStore } from '../lib/session-token';

export const AUTH_UNAUTHORIZED_EVENT = 'zolotalk:unauthorized';

const apiClient = new ApiClient({
  baseUrl: '',
  tokenStore: webTokenStore,
  onUnauthorized: () => {
    window.dispatchEvent(new Event(AUTH_UNAUTHORIZED_EVENT));
  },
});

export { apiClient };

export const learningApi = createLearningApi(apiClient);
export const translationApi = createTranslationApi(apiClient);
export const voiceApi = createVoiceApi(apiClient);
export const ocrApi = createOcrApi(apiClient);
export const historyApi = createHistoryApi(apiClient);
export const vocabularyApi = createVocabularyApi(apiClient);
export const accountApi = createAccountApi(apiClient);
